module.exports = __webpack_public_path__ + "static/img/1013_phase_function_Paper_PointsHejduk_Prediction.25eb5f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1013_phase_function_Paper_PointsHejduk_Prediction.png
// module id = r9dO
// module chunks = 0